<div class="card shadow-none border mb-4 mt-3">
  <div class="card-header py-3 bg-white text-center">
    <h5 class="mb-1">แบบสอบถามความพึงพอใจ</h5>
    <small class="text-body-secondary">กรุณาให้คะแนนความพึงพอใจในแต่ละด้าน เพื่อพัฒนาบริการให้ดียิ่งขึ้น</small>
  </div>

  <div class="card-body">
    @if (errorMessage()) {
      <div class="alert alert-danger mb-3" role="alert" aria-live="assertive">{{ errorMessage() }}</div>
    }

    <form [formGroup]="form" (ngSubmit)="saveSurvey()">
      @if (isLoading()) {
        <div class="text-center py-5 text-body-secondary">กำลังโหลดข้อมูล...</div>
      } @else if (questions().length === 0) {
        <div class="empty-cell">- ไม่มีข้อมูล -</div>
      } @else {
        <div class="survey-help">
          <span class="survey-help-title">เลือกคะแนน 1 ระดับต่อข้อ</span>
          <span class="survey-help-scale">5 = มากที่สุด · 1 = ไม่พึงพอใจ</span>
        </div>

        <div class="survey-items" formGroupName="answers">
          @for (question of questions(); track question.answerKey; let i = $index) {
            <article class="survey-item" [class.is-invalid]="isAnswerInvalid(question.answerKey)">
              <div class="survey-question">
                <span class="survey-no">{{ i + 1 }}</span>
                <span class="survey-title" [id]="'survey-question-' + question.answerKey">
                  {{ question.title }}
                </span>
              </div>

              <fieldset class="survey-rating" [class.is-invalid]="isAnswerInvalid(question.answerKey)"
                        [attr.aria-labelledby]="'survey-question-' + question.answerKey"
                        [attr.aria-describedby]="isAnswerInvalid(question.answerKey) ? 'survey-validation-' + question.answerKey : null"
                        [attr.aria-invalid]="isAnswerInvalid(question.answerKey) ? 'true' : null">
                <legend class="visually-hidden">{{ question.title }}</legend>
                <div class="survey-rating-options">
                  @for (score of scoreOptions; track score) {
                    <input class="survey-score-input" type="radio"
                           [id]="'survey-score-' + question.answerKey + '-' + score"
                           [name]="question.answerKey"
                           [value]="score"
                           [formControlName]="question.answerKey">
                    <label class="survey-score-option" [for]="'survey-score-' + question.answerKey + '-' + score">
                      <span class="survey-score-value">{{ score }}</span>
                    </label>
                  }
                </div>
                @if (isAnswerInvalid(question.answerKey)) {
                  <p class="survey-validation mb-0" [id]="'survey-validation-' + question.answerKey">
                    กรุณาเลือกคะแนน
                  </p>
                }
              </fieldset>
            </article>
          }
        </div>
      }

      <div class="mt-3">
        <label class="form-label" for="suggestion">ข้อเสนอแนะเพิ่มเติม (ไม่บังคับ)</label>
        <textarea id="suggestion" class="form-control form-control-sm" formControlName="suggestion" rows="4"
                  placeholder="กรอกข้อเสนอแนะหรือความคิดเห็นของท่านที่นี่..."></textarea>
      </div>

      <div class="text-center mt-3">
        <button type="submit" class="btn btn-primary"
                [disabled]="isSaving() || isConfirming() || isLoading() || questions().length === 0 || hasDuplicateQuestionIds()">
          @if (isSaving() || isConfirming()) {
            <span class="spinner-border spinner-border-sm me-2"></span>
            {{ isConfirming() ? 'กำลังรอยืนยัน...' : 'กำลังบันทึก...' }}
          } @else {
            ส่งแบบสอบถาม
          }
        </button>
      </div>
    </form>
  </div>
</div>
